import { z } from "zod";

export const createCategorySchema = z.object({
  name: z.string().min(1, "Category name is required"),
  description: z.string().optional(),
  image: z.instanceof(File, { message: "Image is required" }),
});

export const editCategorySchema = z.object({
  name: z.string().min(1, "Category name is required"),
  description: z.string().optional(),
  image: z.union([z.instanceof(File), z.string()]).optional(),
});
